import React from 'react';
import { isEqual } from 'lodash';
import { Row, Col, Divider } from 'antd';

import {
  WorkerHistoryDetailsModel,
  WorkerHistoryRequest,
} from 'api/adminApiClient';
import HistoryField from '../../HistoryField';
import HistoryLog from '../../HistoryLog';

import styles from '../../HistoryCard.module.less';

type Props = {
  historyDetails: WorkerHistoryDetailsModel;
  historyId: string;
};

export default function HomeAddressDetailsCard(props: Props) {
  const { historyDetails, historyId } = props;
  const { oldData, newData } = historyDetails;

  const hasWorkerStateChanged = !isEqual(
    oldData?.location?.state || oldData?.location?.internationalStateName || '',
    newData?.location?.state || newData?.location?.internationalStateName || '',
  );
  const hasWorkerCountryChanged = !isEqual(
    oldData?.location?.country || '',
    newData?.location?.country || '',
  );
  const hasWorkerCityChanged = !isEqual(
    oldData?.location?.city || oldData?.location?.internationalCityName || '',
    newData?.location?.city || newData?.location?.internationalCityName || '',
  );
  const hasWorkerAddressChanged = !isEqual(
    oldData?.location?.address || '',
    newData?.location?.address || '',
  );
  const hasWorkerZipChanged = !isEqual(
    oldData?.location?.zipCode || '',
    newData?.location?.zipCode || '',
  );

  const renderWorkerHomeAddress = (worker?: WorkerHistoryRequest) => {
    if (!worker) return null;

    const { location } = worker;
    const sectionName = 'home-address';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Home address</div>
          </Col>
          {hasWorkerCountryChanged && (
            <HistoryField
              title="Country"
              value={location?.country}
              dataId={`${sectionName}-country-field`}
            />
          )}
          {hasWorkerStateChanged && (
            <HistoryField
              title="State"
              value={location?.state || location?.internationalStateName}
              dataId={`${sectionName}-state-field`}
            />
          )}
          {hasWorkerCityChanged && (
            <HistoryField
              title="City"
              value={location?.city || location?.internationalCityName}
              dataId={`${sectionName}-city-field`}
            />
          )}
          {hasWorkerAddressChanged && (
            <HistoryField
              title="Address"
              value={location?.address}
              dataId={`${sectionName}-address-field`}
            />
          )}
          {hasWorkerZipChanged && (
            <HistoryField
              title="ZIP"
              value={location?.zipCode}
              dataId={`${sectionName}-zip-code-field`}
            />
          )}
        </Row>

        <Divider />
      </>
    );
  };

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderWorkerHomeAddress(oldData)}
      newData={renderWorkerHomeAddress(newData)}
    />
  );
}
